import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { CompaniesFormData } from "../../types";

export const CompanyAddressField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CompaniesFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography>Address</Typography>
      <TextInput
        className="w-full"
        hasError={!!errors.companyAddress}
        placeholder="Enter Address"
        maxLength={512}
        {...register("companyAddress")}
      />
      <ErrorMessage errors={errors} name="companyAddress" />
    </div>
  );
};
